import { render, staticRenderFns } from "./StaffRow.vue?vue&type=template&id=726c884f&"
import script from "./StaffRow.vue?vue&type=script&lang=js&"
export * from "./StaffRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports